import { COUNT_AGGREGATE_BY_TITLE } from '../../constants';
import { MaGraph } from '../../../../../../components/Graphs/MaGraph';
import React from 'react';
import { getGraphLayout } from '../../../../../../components/Graphs/MaGraph/helpers';
import { useGetChartData } from './hooks/useGetChartData';

export const CountChart = () => {
  const yAxisTitle = COUNT_AGGREGATE_BY_TITLE;
  const graphLayout = getGraphLayout({
    showLegend: true,
    yAxisTitle: yAxisTitle,
  });

  const { data, loading, error } = useGetChartData();

  if (error) return null;

  return (
    <MaGraph
      data={data}
      title={`Number of Opportunities by Country`}
      loading={loading}
      graphLayout={graphLayout}
    />
  );
};
